import {Building2, Link2, ShieldAlert, UserRound, UsersRound} from "lucide-react";
import {Link} from "react-router-dom";
import {hasCompletePublishedGraph} from "../statusMachine";
import {useTranslation} from "../../../shared/i18n";


const ResourceRow = ({icon: Icon, label, value, href}) => (
    <li>
        <span className="onboarding-resource-icon" aria-hidden="true">
            <Icon size={17} />
        </span>
        <span>
            <small>{label}</small>
            {href ? <Link to={href}>{value}</Link> : <strong>{value}</strong>}
        </span>
    </li>
);

export const PublishedResources = ({status, resources}) => {
    const {t} = useTranslation();
    const hasAny = Object.values(resources).some((value) => Number.isInteger(value) && value > 0);
    if (!hasAny) return null;

    const complete = hasCompletePublishedGraph(resources);
    const placeId = resources.created_place_id;

    return (
        <section className="onboarding-section" aria-labelledby="onboarding-resources-title">
            <div className="onboarding-section-heading">
                <div>
                    <p className="onboarding-section-kicker">{t("sections.onboarding.p144")}</p>
                    <h2 id="onboarding-resources-title">{t("sections.onboarding.p145")}</h2>
                </div>
                <span>{complete ? "6 / 6" : t("sections.onboarding.p146")}</span>
            </div>

            {status === "published" && !complete ? (
                <div className="onboarding-inline-state onboarding-inline-danger">
                    <ShieldAlert aria-hidden="true" size={18} />
                    <div>
                        <strong>{t("sections.onboarding.p147")}</strong>
                        <p>{t("sections.onboarding.p148")}</p>
                    </div>
                </div>
            ) : null}

            <ul className="onboarding-resource-list">
                {resources.created_user_id ? (
                    <ResourceRow
                        icon={UserRound}
                        label={t("sections.onboarding.p132")}
                        value={t("sections.onboarding.p149", {v0: resources.created_user_id})}
                        href={`/users/${resources.created_user_id}`}
                    />
                ) : null}
                {placeId ? (
                    <ResourceRow
                        icon={Building2}
                        label={t("sections.onboarding.p150")}
                        value={t("sections.onboarding.p151", {v0: placeId})}
                        href={`/employers/${placeId}`}
                    />
                ) : null}
                {resources.created_branch_id ? (
                    <ResourceRow
                        icon={Link2}
                        label={t("sections.onboarding.p134")}
                        value={t("sections.onboarding.p152", {v0: resources.created_branch_id})}
                        href={
                            placeId
                                ? `/employers/${placeId}/branch/${resources.created_branch_id}`
                                : null
                        }
                    />
                ) : null}
                {resources.created_company_id ? (
                    <ResourceRow
                        icon={Building2}
                        label={t("sections.onboarding.p153")}
                        value={t("sections.onboarding.p154", {v0: resources.created_company_id})}
                    />
                ) : null}
                {resources.created_organization_branch_id ? (
                    <ResourceRow
                        icon={Link2}
                        label={t("sections.onboarding.p155")}
                        value={t("sections.onboarding.p156", {v0: resources.created_organization_branch_id})}
                    />
                ) : null}
                {resources.created_staff_member_id ? (
                    <ResourceRow
                        icon={UsersRound}
                        label={t("sections.onboarding.p157")}
                        value={t("sections.onboarding.p158", {v0: resources.created_staff_member_id})}
                    />
                ) : null}
            </ul>
        </section>
    );
};
